module.exports = __webpack_public_path__ + "bed-quilt3.a7d8e9f8.png";